import type { ReactNode } from 'react';

export function Sheet(props: { open: boolean; title: string; onClose: () => void; children: ReactNode }) {
  if (!props.open) return null;
  return (
    <div className="sheet-backdrop" onClick={props.onClose} role="presentation">
      <div className="sheet" role="dialog" aria-modal="true" aria-label={props.title} onClick={(e) => e.stopPropagation()}>
        <h3>
          {props.title}
          <button type="button" className="btn ghost" onClick={props.onClose}>
            Close
          </button>
        </h3>
        {props.children}
      </div>
    </div>
  );
}
